import { ButtonHTMLAttributes } from 'react';
import { getButtonByKind } from './util';
import { Link } from 'react-router-dom';
import {hasClass} from "@app/utils/utils.tsx";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: string | React.ReactNode;
  kind?: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'danger';
  size?: 'default' | 'small';
  onlyIcon?: boolean;
  leftNode?: React.ReactNode;
  rightNode?: React.ReactNode;
  to?: string;
  loading?: boolean;
}
export const Button = ({
  children,
  kind,
  size,
  leftNode,
  rightNode,
  to,
  loading,
  onlyIcon,
  ...rest
}: ButtonProps) => {
  const existingClasses = rest.className ?? '';
  const style = [
      'flex items-center justify-center gap-2 p-2 ',
      getButtonByKind(kind, size),
      !onlyIcon && 'min-w-[200px]',
  ];

  if (!hasClass(existingClasses, 'rounded')) {
    style.push('rounded-lg');
  }

  if (to) {
    return (
      <Link to={to} className={`${style.join(' ')} ${rest.className ?? ''}`}>
        {leftNode && <span>{leftNode}</span>}
        {children && children}
        {rightNode && <span>{rightNode}</span>}
      </Link>
    );
  }
  return (
    <button {...rest} className={`${style.join(' ')} ${rest.className ?? ''} `}>
      {loading ? (
        <div className="flex items-center justify-center">
          <div className="w-5 h-5 border-2 border-t-white border-b-white rounded-full animate-spin" />
        </div>
      ) : (
        <>
          {leftNode && <span>{leftNode}</span>}
          {children && children}
          {rightNode && <span>{rightNode}</span>}
        </>
      )}
    </button>
  );
};
